import { FILTER_OPTION_RANGE_SEPARATOR } from "~/modules/dtwin/constants";

/**
 *
 * @param deviceTypeOptionValue
 * @param rangeOptionValue
 * @returns
 */
export function getFilterDtwinRangeOptionValue(
  deviceTypeOptionValue: string,
  rangeOptionValue: string,
): string {
  return `${deviceTypeOptionValue}${FILTER_OPTION_RANGE_SEPARATOR}${rangeOptionValue}`;
}
